import React, { useState, useEffect } from "react";
import { api, useAxiosInterceptor } from "../shared/axiosInstance";

const UsersList = ({ onSelectUser }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    useAxiosInterceptor();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await api.get("/auth/all-users");
                setUsers(response.data);
            } catch (err) {
                console.error("❌ Error fetching users:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const filteredUsers = users.filter((user) =>
        `${user.firstName} ${user.lastName} ${user.email}`
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
    );

    return (
        <div className="flex flex-col w-64 bg-bluegray rounded-lg shadow-lg p-4">
            <h2 className="text-xl font-bold text-orange mb-3">Manage Users</h2>

            <input
                type="text"
                placeholder="Search users..."
                className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange mb-3"
                onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* Ensure no horizontal scrolling */}
            <div className="overflow-y-auto max-h-[calc(100vh-200px)] pr-2">
                {loading ? (
                    <p className="text-lightgray">Loading...</p>
                ) : filteredUsers.length > 0 ? (
                    <ul className="divide-y divide-lightblue">
                        {filteredUsers.map((user, index) => (
                            <li
                                key={user._id}
                                className={`cursor-pointer p-3 text-lightgray rounded-md hover:bg-orange transition flex flex-col ${
                                    index % 2 === 0 ? "bg-darkblue" : "bg-deepblue"
                                }`}
                                onClick={() => onSelectUser(user._id)}
                            >
                                <strong className="truncate">{user.firstName} {user.lastName}</strong>
                                <p className="text-xs text-lightgray truncate w-full">
                                    {user.email}
                                </p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-red">No users found</p>
                )}
            </div>
        </div>
    );
};

export default UsersList;
